import React from 'react'
import { useEnvValue } from '@morningtrain/react-helpers'
import { useValue } from '@morningtrain/react-resources'

export default function WhenCategoryHasOffsets ({ children }) {
  const ids = useValue('ids', [])

  const [norms] = useEnvValue('globals.inventory.norms.by_item', [])

  if (ids.length === 0) {
    return null
  }

  const normEntries = Object.entries(norms)
    .filter(e => {
      return Object.values(norms[e[0]]).filter(n => n && n.norm_offset).length > 0 && ids.includes(parseInt(e[0]))
    })

  if (normEntries.length === 0) {
    return null
  }

  return children
}
